import axios from "axios";
export default {
	data() {
		/*QUESTO MIXINS E' STATO FATTO DA SISTO, NON SONO STATI IMPLEMENTATI I METODI PER IL LOAD DEL PRESIDIO, 
        MA SOLO QUELLI CHE CARICANO I PRESIDI DELL'UTENTE PERCHE' MI SERVIVANO QUELLI*/
		return {
			presidioJsonData: {},
			presidiOptions: [],
			presidiPathResources: "/strutturepresidi",
			presidiUtentePathResources: "/utentipresidi",
			afterLoadPresidiUtente: null,
		};
	},
	methods: {
		loadPresidiUtente(idUtente, afterLoadPresidiUtente) {
			let me = this;
			this.afterLoadPresidiUtente = afterLoadPresidiUtente;
			let link = process.env.VUE_APP_PATH_API + me.presidiUtentePathResources;
			axios.get(link, { params: { idUtente: idUtente } })
				.then((response) => {
					this.presidiOptions = response.data.data.list;
					if (this.afterLoadPresidiUtente != null) {
						this.afterLoadPresidiUtente();
					}
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		presidiLoadData(afterLoadPresidiUtente = null) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.presidiPathResources;
			axios.get(link, { params: {} })
				.then((response) => {
					this.presidiOptions = []; //response.data.data.list;
					response.data.data.list.forEach((element) => {
						this.presidiOptions.push({ value: element.id, text: element.denominazioneStruttura + " - " + element.denominazione });
					});
					this.presidiOptions.unshift({ value: null, text: "- Presidio -" });
					if (afterLoadPresidiUtente != null) {
						afterLoadPresidiUtente();
					}
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		// struttureLoadData() {
		// 	let me = this;
		// 	let link = process.env.VUE_APP_PATH_API + me.strutturePathResources;
		// 	axios.get(link)
		// 		.then((response) => {
		// 			this.strutturaOptions = response.data.data;
		// 		})
		// 		.catch((error) => {
		// 			this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
		// 				title: "",
		// 				variant: "danger",
		// 				solid: true,
		// 			});
		// 		});
		// },
		// strutturaLoadDataByCodice(codiceStruttura) {
		// 	let me = this;
		// 	let link = process.env.VUE_APP_PATH_API + me.strutturePathResources + "/codice/" + codiceStruttura;
		// 	axios.get(link)
		// 		.then((response) => {
		// 			this.strutturaJsonData = response.data.data;
		// 		})
		// 		.catch((error) => {
		// 			this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
		// 				title: "",
		// 				variant: "danger",
		// 				solid: true,
		// 			});
		// 		});
		// },
		// strutturaLoadDataByCodiceCallBack(codiceStruttura, callBack) {
		// 	let me = this;
		// 	let link = process.env.VUE_APP_PATH_API + me.strutturePathResources + "/codice/" + codiceStruttura;
		// 	axios.get(link)
		// 		.then((response) => {
		// 			callBack(response.data.data)
		// 		})
		// 		.catch((error) => {
		// 			this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
		// 				title: "",
		// 				variant: "danger",
		// 				solid: true,
		// 			});
		// 		});
		// },
	},
};
